// Scrolls to a target top position within the nearest element scroller
// (the page's #content, or a PageShell content pane), falling back to the
// window when the element isn't inside one (e.g. Storybook).
export const scrollElementIntoView = (
  element: HTMLElement,
  offset = 0,
): void => {
  const container = element.closest<HTMLElement>("[data-scroll-container]");
  const top = element.getBoundingClientRect().top - offset;

  if (container) {
    container.scrollTo({
      top: top - container.getBoundingClientRect().top + container.scrollTop,
      behavior: "smooth",
    });
  } else {
    window.scrollTo({ top: top + window.scrollY, behavior: "smooth" });
  }
};
